import { useCallback, useEffect, useState } from 'react';
import './supRating.css';
import ReactLoading from 'react-loading';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { supBookingsServiceConfig } from '../../utils/supportServiceConfig/supBookingsServiceConfig';
import { userReview } from '../../api/userAPI';
import { toast } from 'react-toastify';
import RateTrip from '../../components/ratingTrip/rateTrip';
import { supUserReview } from '../../api/supportAdmin';

const MODE_TO_SERVICE = {
    t: 'trip',
    a: 'act',
    c: 'camp',
    g: 'guide'
};

const SupRating = () => {
    const { orgId, mode } = useParams();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [serviceType, setServiceType] = useState('trip');
    const [datesType, setDatesType] = useState('fixed');
    const [group, setGroup] = useState('backpacking');
    const [selectedTrip, setSelectedTrip] = useState('trip');
    const [trips, setTrips] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState('');
    const [orgData, setOrgData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState([]);
    const [userRating, setUserRating] = useState(0);
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [comment, setComment] = useState('');
    const [popupRating, setPopupRating] = useState(userRating);
    const [phoneNumber, setPhoneNumber] = useState('');

    const dummyMessageType = [
        { value: 'whatsApp', name: 'WhatsApp' },
        { value: 'rate', name: 'Rate' },
        { value: 'custom', name: 'Custom' }
    ];

    const serviceBookingConfig = supBookingsServiceConfig[serviceType];

    const SERVICE_TO_MODE = {
        trip: 't',
        act: 'a',
        camp: 'c',
        guide: 'g'
    };

    const handleServiceType = (e) => {
        const selectedValue = e.target.value;
        setServiceType(selectedValue);
        const newMode = SERVICE_TO_MODE[selectedValue];
        navigate(`/support/${newMode}/rating`);
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const fetchOrg = async () => {
            serviceBookingConfig.fetchOrg({ serviceType, setOrgData, setLoading });
        };
        fetchOrg();
    }, [serviceType]);

    useEffect(() => {
        const fetchBookingData = async () => {
            serviceBookingConfig.fetchTrips({ selectedOrg, setTrips, datesType, group, setLoading, serviceType });
        };
        fetchBookingData();
        setMessageType(dummyMessageType);
        //eslint-disable-next-line
    }, [selectedTrip, selectedOrg, datesType, group]);

    const openRatingModal = (e) => {
        e.stopPropagation();
        setShowRatingModal(true);
        setPopupRating(userRating);
    };

    const closeRatingModal = () => {
        setShowRatingModal(false);
    };

    const handleSubmitRating = async (e) => {
        e.preventDefault();

        const ratingData = {
            packId: selectedTrip,
            phoneNumber: phoneNumber,
            rating: popupRating,
            organizerId: selectedOrg,
            comment
        };

        try {
            const res = await supUserReview(serviceType, ratingData);
            console.log(res);
            if (res.status === 200) {
                toast.success('Thank you! Your rating has been submitted');
                setUserRating(popupRating);
                setPhoneNumber('');
                setComment('');
                setPopupRating('');
                closeRatingModal();
            }
        } catch (error) {
            console.error('Error submitting rating:', error);
            toast.error(error.response.data.message);
            setShowRatingModal(true);
        }
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='ratingDiv'>
                <div className='orgBookingFilters'>
                    <select
                        name='serviceType'
                        id='serviceType'
                        className='select mr-1'
                        onChange={(e) => {
                            handleServiceType(e);
                        }}
                    >
                        <option value='trip'>Trip</option>
                        <option value='act'>Activity</option>
                        <option value='guide'>Guide</option>
                        <option value='camp'>Camp</option>
                    </select>
                    <select
                        name='org'
                        id='org'
                        className='select'
                        value={selectedOrg}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSelectedOrg(value);
                        }}
                    >
                        <option value=''>Select Organizer</option>
                        {orgData.map((org) => (
                            <option value={org._id} key={org._id}>
                                {org.companyName}
                            </option>
                        ))}
                    </select>
                    {serviceType === 'trip' && (
                        <>
                            <select
                                name='datesType'
                                id='datesType'
                                className='select'
                                value={datesType}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setDatesType(value);
                                }}
                            >
                                <option value='fixed'>Fixed</option>
                                <option value='custom'>Custom</option>
                            </select>
                            <select
                                name='datesType'
                                id='datesType'
                                className='select'
                                value={group}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedOrg(value);
                                }}
                            >
                                <option value='backpacking'>Backpacking</option>
                                <option value='vehicle'>Vehicle</option>
                            </select>
                        </>
                    )}

                    <select
                        name='trip'
                        id='trip'
                        className='select'
                        value={selectedTrip}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSelectedTrip(value);
                            setShowRatingModal(true);
                        }}
                    >
                        <option value=''>Select Trip</option>
                        {trips.map((trip) => (
                            <option value={trip._id} key={trip._id}>
                                {trip.title}
                            </option>
                        ))}
                    </select>
                </div>
                {selectedTrip && (
                    <div>
                        <div className='mobileDiv'>
                            <label
                                style={{ marginTop: 10, width: '150px' }}
                                htmlFor='vehicleModel'
                                className='dropRegLabel'
                            >
                                Enter Mobile No :
                            </label>
                            <div className='dropRegInputDiv'>
                                <input
                                    id='phoneNumber'
                                    name={'phoneNumber'}
                                    type='text'
                                    className='dropRegSelect'
                                    placeholder={'10 digits'}
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='modalContent'>
                            <RateTrip
                                props={{
                                    popupRating,
                                    setPopupRating,
                                    comment,
                                    setComment
                                }}
                            />
                            <div className='modalActions'>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        closeRatingModal(e);
                                    }}
                                    className='closeModal'
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        closeRatingModal(e);
                                        handleSubmitRating(e);
                                    }}
                                    className='submitRating'
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default SupRating;
